import { healthCheck } from './http';
import { deleteImpactService, scrapeService, wizardService } from './services/actions';
import { activityService } from './services/activity';
import { categoriesService } from './services/categories';
import { configService } from './services/config';
import { dashboardService, telegramService } from './services/dashboard';
import { searchesService } from './services/searches';
import { sourcesService } from './services/sources';
import { subscriptionsService } from './services/subscriptions';
import { usageService } from './services/usage';
import { billingService } from './services/billing';
import { billingAdminService } from './services/billingAdmin';
import { paymentProvidersService } from './services/paymentProviders';
import { authService } from './services/auth';
import { meService } from './services/me';
import { recipientsService } from './services/recipients';
import { usersService } from './services/users';
import { jobsService } from './services/jobs';
import { maintenanceService } from './services/maintenance';
import { searchExecutionsService } from './services/searchExecutions';
import { scrapeAnalyticsService } from './services/scrapeAnalytics';
import { notificationsService, subscriptionService } from './services/notifications';
import { organizationsService } from '@/api/services/organizations';
import { workspaceUsersService } from '@/api/services/workspaceUsers';
import { supportService } from './services/support';
import { customerActivityService } from './services/customerActivity';
import { customerBillingService } from './services/customerBilling';
import { templatesService } from './services/templates';
import { adminBillingService } from './services/adminBilling';

/** Facade matching the previous monolithic `api` object — pages import this. */
export const api = {
  health: healthCheck,
  users: usersService,
  recipients: recipientsService,
  searches: searchesService,
  subscriptions: subscriptionsService,
  deleteImpact: deleteImpactService,
  sources: sourcesService,
  categories: categoriesService.list,
  config: configService,
  wizard: wizardService,
  scrape: scrapeService,
  dashboard: dashboardService,
  telegram: telegramService,
  deliveries: activityService.deliveries,
  deliveriesPaginated: activityService.deliveriesPaginated,
  getDeliveryDetail: activityService.getDeliveryDetail,
  retryDelivery: activityService.retryDelivery,
  bulkRetryDeliveries: activityService.bulkRetryDeliveries,
  resendDelivery: activityService.resendDelivery,
  discoveredLinks: activityService.discoveredLinks,
  discoveredLinksPaginated: activityService.discoveredLinksPaginated,
  fetchRuns: activityService.fetchRuns,
  bulkDeleteDeliveries: activityService.bulkDeleteDeliveries,
  relatedJobForDelivery: activityService.relatedJobForDelivery,
  cleanupDeliveries: activityService.cleanupDeliveries,
  activityLogs: activityService.activityLogs,
  bulkClearActivityLogs: activityService.bulkClearActivityLogs,
  cleanupActivityLogs: activityService.cleanupActivityLogs,
  clearActivityForSearch: activityService.clearActivityForSearch,
  clearActivityForSource: activityService.clearActivityForSource,
  usage: usageService,
  billing: billingService,
  billingAdmin: billingAdminService,
  paymentProviders: paymentProvidersService,
  me: meService,
  auth: authService,
  jobs: jobsService,
  maintenance: maintenanceService,
  searchExecutions: searchExecutionsService,
  scrapeAnalytics: scrapeAnalyticsService,
  notifications: notificationsService,
  subscription: subscriptionService,
  organizations: organizationsService,
  workspaceUsers: workspaceUsersService,
  support: supportService,
  customerActivity: customerActivityService,
  customerBilling: customerBillingService,
  templates: templatesService,
  adminBilling: adminBillingService,
};

export {
  ACCOUNT_REMOVED_MESSAGE,
  AUTH_SESSION_ENDED_EVENT,
  ApiError,
  clearAccessToken,
  clearApiKey,
  consumeAuthNotice,
  getAccessToken,
  getApiKey,
  request,
  setAccessToken,
  setApiKey,
} from './http';
export type {
  Category,
  DeleteImpact,
  DeleteResult,
  Delivery,
  DiagnosticCheck,
  DiagnosticsData,
  DiscoveredLink,
  FetchRun,
  HealthData,
  Paginated,
  RuntimeInfo,
  ScrapeRunResult,
  Search,
  Source,
  Subscription,
  TelegramSendResult,
  User,
  WizardResult,
  UsageSummary,
  BillingStatus,
  BillingCheckoutResult,
  BillingPortalResult,
  MeProfile,
  MePermissions,
  Job,
  JobItem,
  JobListParams,
  JobSummary,
  JobAttempt,
  JobAttemptListParams,
  SearchExecution,
  SearchExecutionListParams,
  SearchExecutionListResponse,
  WorkerHeartbeatSummary,
  QueueSummary,
  ActivityLog,
  ActivityLogListParams,
} from './types';
